import { useState, useRef } from 'react';
import { history, useDispatch, useIntl } from 'umi';
import { Box, Card, CardContent } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import Button from '@material-ui/core/Button';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';

export default () => {
  //国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const [searchVal, setSearchVal] = useState('');
  const searchRef = useRef();
  const searchKeyUpRef = useRef();
  const { pathname } = history?.location;
  // 查询事件处理
  const handleSearchClick = () => {
    if (searchVal) {
      dispatch({
        type: 'ml/getMemberDetail',
        payload: {
          values: {
            mobile: searchVal,
            memberCode: searchVal,
          },
        },
        callback: (response) => {
          const { data: memberInfo = {} } = response;
          if (memberInfo?.id) {
            history.push({
              pathname:
                pathname === '/dealer-customer/emp_search'
                  ? '/dealer-customer/emp_search/detail'
                  : '/cm/emp_search/detail',
              query: {
                mobile: searchVal,
                memberCode: searchVal,
                tab: 0,
                sourceOid: 'btn_offline_store_customer_search_details_search',
              },
            });
          }
        },
      });
    }
  };

  // 重置事件处理
  const handleRestClick = () => {
    setSearchVal('');
  };

  return (
    <>
      <Card className="emp-search-box">
        <CardContent className="search-content">
          <Box display="flex" flexDirection="row" alignItems="flex-end">
            <SearchIcon sx={{ width: '52px', height: '52px' }} color="info" />
            <Box
              display="flex"
              flexDirection="column"
              className="left-words-box"
            >
              <span className="word1">
                {formatMessage({ id: 'cm.search.n01.lbl02' })}
              </span>
              <span className="word2">Member search</span>
            </Box>
          </Box>
          <Box>
            <TextField
              ref={searchKeyUpRef}
              data-log={JSON.stringify({
                oid: 'btn_offline_store_customer_search_details_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              name="memberCode"
              variant="standard"
              label={formatMessage({ id: 'cm.search.n01.placeholder03' })}
              fullWidth
              value={searchVal}
              onChange={(e) => {
                setSearchVal(e.target.value);
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') {
                  window.NE_DAWN.trigger(searchKeyUpRef.current, {
                    event: '_ec', // 事件名
                    params: { mobile: searchVal, memberCode: searchVal }, // 事件公参
                  });
                  handleSearchClick();
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={() => {
                        setSearchVal('');
                      }}
                      edge="end"
                    >
                      {searchVal ? <ClearIcon className="clear-icon" /> : ''}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'cm.black.n01.btn05' })}
            </Button>

            <Button
              ref={searchRef}
              data-log={JSON.stringify({
                oid: 'btn_offline_store_customer_search_details_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              variant="contained"
              type="submit"
              className="search"
              onClick={() => {
                window.NE_DAWN.trigger(searchRef.current, {
                  event: '_ec', // 事件名
                  params: { mobile: searchVal, memberCode: searchVal }, // 事件公参
                });
                handleSearchClick();
              }}
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'cm.black.n01.btn06' })}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};
